/* JC CUSTOM: BF セールLP — アンカーナビ scroll-spy（03 ANCHOR NAV）
 * - IntersectionObserver でビューポート中央帯に入っているゾーンを検出し、
 *   対応するナビ項目に is-active を付け替える
 * - JS が無効でも初期状態（左が active）で成立する。グローバル汚染なし
 */
(function () {
  'use strict';

  function init() {
    var nav = document.querySelector('.bf-nav');
    if (!nav || !('IntersectionObserver' in window)) return;

    var items = Array.prototype.slice.call(nav.querySelectorAll('.bf-nav__item[data-bf-zone]'));
    var zones = [];
    items.forEach(function (item) {
      var el = document.getElementById(item.getAttribute('data-bf-zone'));
      if (el) zones.push({ el: el, item: item });
    });
    if (zones.length < 2) return;

    var visible = {};
    var current = null;

    function setActive(zone) {
      if (current === zone) return;
      current = zone;
      items.forEach(function (item) {
        item.classList.toggle('is-active', item === zone.item);
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          visible[entry.target.id] = entry.isIntersecting;
        });
        // 文書順で最後に中央帯へ入っているゾーンを現在地とする
        var active = null;
        zones.forEach(function (zone) {
          if (visible[zone.el.id]) active = zone;
        });
        if (active) setActive(active);
      },
      { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
    );

    zones.forEach(function (zone) {
      observer.observe(zone.el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
